import TlSetHardDiskSlarmModal from './tl-set-hard-disk-alarm-modal.vue'
export default TlSetHardDiskSlarmModal
